<template>
  <div
    class="custom-error-message"
  >
    <span class="custom-error-message__title">
      {{ errorDetails.title }}
    </span>
    <p class="custom-error-message__description">
      {{ errorDetails.description }}
    </p>
  </div>
</template>

<script>
import { ERROR_MAP } from '@/utils/constants';

export default {
  name: 'CustomErrorMessage',
  props: {
    requestStatus: {
      type: String,
      default: 'error',
    },
  },
  computed: {
    errorDetails() {
      if (Boolean(ERROR_MAP.includes(this.requestStatus))) {
        return {
          title: this.$t(`components.CustomErrorMessage.label.${this.requestStatus}.title`),
          description: this.$t(`components.CustomErrorMessage.label.${this.requestStatus}.description`),
        };
      }
      return {
        title: '',
        description: this.$t('components.CustomErrorMessage.label.error.description'),
      };
    },
  },
};
</script>

<style scoped lang="scss">
  .custom-error-message {
    display: flex;
    flex-direction: column;
    align-items: center;

    &__title {
      color: var(--ds-color-text-1);
    }

    &__description {
      margin-top: var(--ds-spacing-inset-nano);
      text-align: center;
    }
  }
</style>
